<template>
  <div id="q-app">
    <router-view />

    <div id="fullpage-loader"
    	v-if="loading"
    >
	    <q-spinner-gears
	      color="primary"
	      size="4em"
	    />
	</div>
  </div>
</template>

<script>

export default {
  name: 'App',
  computed:{
  	loading: function() {
  		return this.$store.state.globalstore.loading
  	}
  },
  beforeMount: function() {
    // Détection du domaine et initialisation du branding
    const hostname = window.location.hostname
    this.$store.dispatch('branding/initBranding', hostname)
    
    // Mise à jour du titre et favicon selon le branding
    const branding = this.$store.state.branding.branding
    document.title = branding.name || 'Qualifop'
    
    // Mise à jour du favicon pour Syn'APPs
    if (branding.useSvgLogo) {
      const favicon = document.querySelector('link[rel="icon"]')
      if (favicon) {
        const svgFavicon = `data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="46" fill="%2335505B"/><path d="M68 28 C62 20, 38 20, 32 32 C28 40, 34 46, 50 50 C66 54, 72 60, 66 70 C60 80, 36 80, 32 70" fill="none" stroke="%23FFFFFF" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/></svg>`
        favicon.href = svgFavicon
      }
    }
    
    // Log pour debug (à retirer après validation)
    console.log('🎨 Branding initialisé pour:', hostname)
    console.log('📦 Configuration:', this.$store.state.branding.branding)
    console.log('🔦 Mode Light:', this.$store.state.branding.isLightMode)
	  // Check if authenticated
  }
}
</script>

<style>
  /* @font-face{
    font-family:"Wigrum";
    src:url(assets/fonts/Wigrum-Regular.otf)
  } */

  :root {
    font-family: Inter, sans-serif;
    font-feature-settings: 'liga' 1, 'calt' 1; /* fix for Chrome */
  }
  @supports (font-variation-settings: normal) {
    :root { font-family: InterVariable, sans-serif; }
  }

	#fullpage-loader{
		position: fixed;
		top: 50px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		background: rgba(255,255,255,0.5);
		z-index: 9990;
		display: flex;
		align-items: center;
		justify-content: center;

	}
  .vue-notification-group {
    z-index: 9999;
  }

  .q-field__native[required] ~ .q-field__label:after {
    content: '*';
    color: red;
  }

</style>
